export default __webpack_public_path__ + "static/media/soldier.a477f33b.png";